import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutoFocusDirective } from './directives/auto-focus.directive';
import { EditorAutoFocusDirective } from './directives/editor-auto-focus.directive';
import { MediaBrokenDirective } from './directives/media-broken.directive';
import { PreviewDeviceDirective } from './directives/preview-device-styling.directive';
import { ScrollToComponentTopDirective } from './directives/scroll-top.directive';
import { JoinConditionValuesPipe } from './pipes/join-values.pipe';
import { QuestionOptionTitlePipe } from './pipes/question-option-title.pipe';
import { QuestionTitlePipe } from './pipes/question-title.pipe';
import { QuestionToOptionPipe } from './pipes/question-to-option.pipe';
import { QuestionTypePipe } from './pipes/question-type.pipe';
import { RankTextByType } from './pipes/rank-text-by-type';
import { ToFormArrayPipe } from './pipes/to-form-array.pipe';
import { ToFormControlPipe } from './pipes/to-form-control.pipe';
import { ToFormGroupPipe } from './pipes/to-form-group.pipe';
import { ToOrdinalNumberPipe } from './pipes/to-ordinal-number.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AutoFocusDirective,
    EditorAutoFocusDirective,
    PreviewDeviceDirective,
    MediaBrokenDirective,
    ScrollToComponentTopDirective,
    JoinConditionValuesPipe,
    QuestionOptionTitlePipe,
    QuestionTitlePipe,
    QuestionTypePipe,
    QuestionToOptionPipe,
    RankTextByType,
    ToFormArrayPipe,
    ToFormControlPipe,
    ToFormGroupPipe,
    ToOrdinalNumberPipe
  ],
  exports: [
    AutoFocusDirective,
    EditorAutoFocusDirective,
    PreviewDeviceDirective,
    MediaBrokenDirective,
    ScrollToComponentTopDirective,
    JoinConditionValuesPipe,
    QuestionOptionTitlePipe,
    QuestionTitlePipe,
    QuestionToOptionPipe,
    QuestionTypePipe,
    RankTextByType,
    ToFormArrayPipe,
    ToFormControlPipe,
    ToFormGroupPipe,
    ToOrdinalNumberPipe
  ]
})
export class SurveyCoreModule {}
